import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import VideoCard from '../components/VideoCard';
import { useYoutubeApi } from '../context/YoutubeApiContext';

export default function Videos() {
    const { keyword } = useParams(); // keyword를 사용하여 어떤 키워드였는지 출력한다.
    const { youtube } = useYoutubeApi();
    const { isLoading, error, data: videos } = useQuery({
        queryKey: ['videos', keyword],
        queryFn: () => youtube.search(keyword),
        staleTime: 1000 * 60 * 1,
    }); // fetch 대신 axios를 사용한다.

    return (
        <div>
            {isLoading && <p>Loading...</p>}
            {error && <p>Something is wrong ㅜㅜ</p>}
            {videos && (
                <ul className='row list-unstyled'>
                    {videos.map((video) => (
                        <div key={video.id} className='col-12 col-sm-6 mb-4 col-lg-4 col-xl-3 col-xxl-2 g-2 gy-4'>
                            <VideoCard key={video.id} video={video} />
                        </div>
                    ))}
                </ul>
            )}

        </div>
    );
}

